/**
 * Check if a photo is displayed in landscape orientation.
 * @param {object} photoData - The photo data object. Includes exif orientation and katapult added rotation flag.
 * @returns {boolean} - True if the photo is displayed in landscape orientation, false otherwise.
 */
export function IsPhotoDisplayedLandscape(photoData) {
  const exifOrientationToDegrees = {
    1: 0,
    6: 90,
    3: 180,
    8: 270,
    2: 0,
    5: 90,
    4: 180,
    7: 270
  };
  const katapultRotationToDegrees = {
    0: 0,
    1: 90,
    2: 180,
    3: 270
  };
  const orientation = photoData?.orientation;
  if (!orientation) return null;
  const katapultRotation = photoData?.rotation ?? 0;
  const exifRotationDegrees = exifOrientationToDegrees[orientation];
  const katapultRotationDegrees = katapultRotationToDegrees[katapultRotation];
  const totalRotationDegrees = (exifRotationDegrees + katapultRotationDegrees) % 360;

  return totalRotationDegrees === 0 || totalRotationDegrees === 180;
}
